import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DataGridComponent } from './data-grid.component';

/**
 * The grid's checkbox-selection pill (WAP-1729): count + Clear, projected by
 * the host into `<app-data-grid>`'s `[toolbarStatus]` slot on a grid with
 * `[checkboxSelection]="true"`. A view over the wrapper's selection
 * (`selectionCount()` / `clearSelection()`, WAP-1739): the wrapper owns the
 * selected ids, empties them on a filter change and on every purge (Refresh, a
 * store filter, the quick search) and keeps them across an in-place
 * `refreshAfterEdit()`, so no stale id survives into a bulk dialog and an edit
 * does not cost the user their ticks. Reaches the grid through DI, so the
 * element must sit inside `<app-data-grid>`. Declared in SensikaAgGridModule
 * (fa-icon, translate).
 */
@Component({
  selector: 'app-grid-selection',
  templateUrl: './grid-selection.component.html',
  styleUrls: ['./grid-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GridSelectionComponent {
  private readonly grid = inject(DataGridComponent);

  readonly count = this.grid.selectionCount;

  /** Empties the selection (the pill's Clear; the bulk scope falls back to "all matching filters"). */
  clear(): void {
    this.grid.clearSelection();
  }
}
